
// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
import observeAndExecute from './utils/observe-and-execute';
const fCarousels = require('./components/carousels');
const fAdjustSticky = require('./components/adjust-sticky')
// const fSelect = require('./components/select');
// const fGsapController = require('./components/gsap-controller')
// const fVueComponents = require('./components/vue-components');

// Initialise our components on jQuery.ready…

    fSmoothScroll()
    fAdjustSticky.init()
    // fVueComponents.init()
    // fSelect.init()
    // fGsapController.init()

    observeAndExecute(".swiper", {
        callback: () => fCarousels.init(),
        disconnect: true,
    })

const toggleButtons = document.querySelectorAll('.toggle-menu');
const sideMenu = document.querySelector('.side-menu');

// Loop through each toggle button
toggleButtons?.forEach((toggleButton) => {
    // Add a click event listener for each toggle button
    toggleButton.addEventListener('click', () => {
        // Toggle the 'active' class on the corresponding side menu
        sideMenu?.classList.toggle('active');
        // document.body.classList.toggle('overflow-hidden')
    });
});
